import { Font } from '@react-pdf/renderer';
import PropTypes from "prop-types";
import { extractResumeProperties } from "../../hooks/useResumeProperties";
import FontArial from '../assets/font/arial.ttf';
import FontArialBold from '../assets/font/G_ari_bd.TTF';
import FontVerdanaBold from '../assets/font/Verdana-Bold.ttf';
import FontVerdana from '../assets/font/Verdana.ttf';
import CommonPdf from "./common/CommonPdf";
import CssfPdf from "./cssf/CssfPdf";
import EuropassPdf from "./europass/EuropassPdf";

Font.register( {
    family: 'Arial, sans-serif',
    fonts: [
        { src: FontArial, fontWeight: 'normal' },
        { src: FontArialBold, fontWeight: 'bold' },
    ],
} );

Font.register( {
    family: 'Verdana, sans-serif',
    fonts: [
        { src: FontVerdana, fontWeight: 'normal' },
        { src: FontVerdanaBold, fontWeight: 'bold' },
    ],
} );

export default function ResumePdf( { resumeData, translations } ) {
    const { isEuropass, isCssf } = extractResumeProperties( resumeData );

    if ( isEuropass ) {
        return <EuropassPdf resumeData={ resumeData } translations={ translations }/>;
    }

    if ( isCssf ) {
        return <CssfPdf resumeData={ resumeData } translations={ translations }/>;
    }

    return <CommonPdf resumeData={ resumeData } translations={ translations }/>;
}

ResumePdf.propTypes = {
    resumeData: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired,
}
